import { SVGProps } from 'react'

export const PinIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='12'
    height='13'
    viewBox='0 0 12 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.125 5C10.125 8.375 6 12.125 6 12.125C6 12.125 1.875 8.375 1.875 5C1.875 2.72183 3.72183 0.875 6 0.875C8.27817 0.875 10.125 2.72183 10.125 5Z'
      fill='white'
      stroke='white'
      strokeWidth='0.75'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <circle cx='6' cy='5' r='1.875' fill='#1e9575' />
  </svg>
)
